export default __webpack_public_path__ + "assets/images/4a4f88ad75b30911ef1583d1902203dd.png";